/*global google*/
import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from "axios";

import AdminHeaderNew from '../Common/AdminHeader';
// import AdminSideBarNew from '../Common/AdminSideBar'; // Not needed — this page is only for schemeCode="16" (MNT), which uses AdminSideBarMnt
import AdminSideBarMnt from '../Common/AdminSidebarMnt';
import AdminFooterNew from '../Common/AdminFooter';
import '../../../assets/styles/Style.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import kmLogo from "../../../assets/images/km_logo.png";



function AssignTargetMNT() {

    const [latestSurveyCount, setLatestSurveyCount] = useState([]);
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);
    const [statesData, setStatesData] = useState([]);
    const [schemeData, setSchemeData] = useState([]);
    const [assignTargetListing, setAssignTargetListing] = useState([]);
    const [targetPlaceholder, setTargetPlaceholder] = useState("000000");
    //const [revisedTargetPlaceholder, setRevisedTargetPlaceholder] = useState("000000");
    const [assignDistrictTarget, setAssignDistrictTarget] = useState("");
    const [assignSubDistrictTarget, setAssignSubDistrictTarget] = useState("");
    const [assignTarget, setAssignTarget] = useState("");
    const [missionTargetSummary, setMissionTargetSummary] = useState([]);
    const [summaryString, setSummaryString] = useState('');

    //const [revisedTarget, setRevisedTarget] = useState("");
    const [stateValue, setStateValue] = useState('');
    const [schemeValue, setSchemeValue] = useState('');
    const [subDistrictValues, setSubDistrictValues] = useState('');
    const [revisedByState, setRevisedByState] = useState('');
    const [revisedTargetByState, setRevisedTargetByState] = useState('');
    const [villageCode, setVillageCode] = useState('');
    const [uom, setUom] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editRow, setEditRow] = useState(null);
    const [showModals, setShowModals] = useState(false);
    const [finYear, setFinYear] = useState(() => {
        return getCurrentFinancialYear();
    });
    // const [finYear, setFinYear] = useState(() => {
    //     // read default from sessionStorage; fallback to 2024-2025
    //     const stored = sessionStorage.getItem("finYear");
    //     return stored && (stored === "2024-2025" || stored === "2025-2026") ? stored : "2025-2026";
    // });
    // const finYearStatic = getCurrentFinancialYear();
    const finYearStatic = getCurrentFinancialYear();
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const currentSchemeName = sessionStorage.getItem("currentSchemeName");
    const currentStateName = sessionStorage.getItem("currentStateName");
    const currentDistrictName = sessionStorage.getItem("currentDistrictName");
    const [districtValue, setDistrictValue] = useState('');
    const [subDistrictData, setSubDistrictData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showTargetInput, setShowTargetInput] = useState(false);
    const userType = sessionStorage.getItem("userRoleCodeModel");
    const [expandedRowData, setExpandedRowData] = useState([]);

    const [ddlSubTypeList, setDDlSubTypeList] = useState([]);
    const [txtlType, setTxtlType] = useState("");
    const [selectedValue, setSelectedValue] = useState('NA');

    //const [otherText, setOtherText] = useState('');
    const [rows, setRows] = useState([]);
    // const lastSerializedRef = useRef('');
    const [rowValues, setRowValues] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [isStateRevised, setIsStateRevised] = useState(false);
    const [isYesButtonDisabled, setIsYesButtonDisabled] = useState(false);
    const [assignTargetReports, setAssignTargetReports] = useState([]);
    const [selectedTypeData, setSelectedTypeData] = useState({
        revisedTargetByState: '',
        centralMission: '',
        uomType: '',
        districtName: '',
        districtMission: ''
    });
    const [groupedSchemeData, setGroupedSchemeData] = useState([]);
    const [formData, setFormData] = useState({
        schemeName: "",
        stateName: "",
        districtName: "",
        missionTarget: "",
        finYear: ""
    });

    // Pagination state variables
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
    const [searchState, setSearchState] = useState('');
    const [searchType, setSearchType] = useState('');


    const handleFinYearChange = (e) => {
        const value = String(e.target.value || "");
        sessionStorage.setItem("finYear", value);
        setFinYear(value);
        assignTargetData(value);
    };


    const handleRowClearVillage = () => {
        // Reset the SubType select
        setSelectedValue('');

        // Reset the selected type data
        setSelectedTypeData({
            revisedTargetByState: '',
            uomType: '',
            centralMission: ''
        });

        // Clear village options
        setOptionVillage([]);

        // Reset the row values (Village and Assign Target)
        setRowValues(prev =>
            prev.map((row, i) => ({
                ...row,
                villageValue: "",
                targetValue: ""
            }))
        );
    };

    function getCurrentFinancialYear() {
        const today = new Date();
        let year = today.getFullYear();

        // If month is Jan, Feb, or Mar (0 = Jan), financial year starts from previous year
        if (today.getMonth() < 3) {
            return `${year - 1}-${year}`;
        } else {
            return `${year}-${year + 1}`;
        }
    }
    const getMissionValue = (survey, userType) => {
        switch (userType) {
            case "1":
                return survey.centralMission;
            case "2":
                return survey.districtMission;
            case "3":
                return survey.subDistrictMission;
            case "4":
            case "5":
                return survey.villageMission;
            default:
                return 0;
        }
    };

    const getMissionValueByUserType = (survey, userType) => {
        switch (userType) {
            case "1":
                return survey.centralMission;
            case "2":
                return survey.districtMission;
            case "3":
                return survey.subDistrictMission;
            case "4":
            case "5":
                return survey.villageMission;
            default:
                return 0;
        }
    };

    const handleRowClearSubDistrict = () => {
        // Reset the SubType select
        setSelectedValue('');

        // Reset the selected type data
        setSelectedTypeData({
            revisedTargetByState: '',
            uomType: '',
            centralMission: ''
        });
    };

    // Pagination functions
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    // Filter and paginate the data
    const getPaginatedData = () => {
        console.log("assignTargetListing--------------", assignTargetListing);
        let filteredData = assignTargetListing.filter((survey, index) => {
            const shouldShow =
                (userType === "3" && survey.subDistrictName !== null) ||
                (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
            return shouldShow;
        });

        // Filter by mission value > 0
        filteredData = filteredData.filter((survey) => {
            const missionValue = getMissionValueByUserType(survey, userType);
            return missionValue && missionValue > 0;
        });

        // Apply search filters
        if (searchState || searchType) {
            filteredData = filteredData.filter((survey) => {
                const stateMatch = !searchState || (survey.stateName === searchState);
                const typeMatch = !searchType || (survey.schemeSubTypeName === searchType);
                return stateMatch && typeMatch;
            });
        }

        return filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    };

    // Get all filtered data (for export, without pagination)
    const getAllFilteredData = () => {
        let filteredData = assignTargetListing.filter((survey, index) => {
            const shouldShow =
                (userType === "3" && survey.subDistrictName !== null) ||
                (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
            return shouldShow;
        });

        // Apply search filters
        if (searchState || searchType) {
            filteredData = filteredData.filter((survey) => {
                const stateMatch = !searchState || (survey.stateName === searchState);
                const typeMatch = !searchType || (survey.schemeSubTypeName === searchType);
                return stateMatch && typeMatch;
            });
        }

        // Filter by mission value > 0
        return filteredData.filter((survey) => {
            const missionValue = getMissionValueByUserType(survey, userType);
            return missionValue && missionValue > 0;
        });
    };

    // Get filtered data count for pagination
    const getFilteredDataCount = () => {
        let filteredData = assignTargetListing.filter((survey, index) => {
            const shouldShow =
                (userType === "3" && survey.subDistrictName !== null) ||
                (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
            return shouldShow;
        });

        // Apply search filters
        if (searchState || searchType) {
            filteredData = filteredData.filter((survey) => {
                const stateMatch = !searchState || (survey.stateName === searchState);
                const typeMatch = !searchType || (survey.schemeSubTypeName === searchType);
                return stateMatch && typeMatch;
            });
        }

        // Filter by mission value > 0
        filteredData = filteredData.filter((survey) => {
            const missionValue = getMissionValueByUserType(survey, userType);
            return missionValue && missionValue > 0;
        });

        return filteredData.length;
    };
  const getAchievementMeta = (missionValue, completeValue) => {
        const missionTarget = Number(missionValue || 0);
        const achieved = Number(completeValue || 0);

        if (!missionTarget || missionTarget === 0) {
            return { percent: "0.00", color: "bg-secondary", label: "N/A" };
        }

        // ✅ ACTUAL percentage (no cap at 100)
        const percent = (achieved / missionTarget) * 100;

        let color = "bg-danger";
        let label = "Poor";

        if (percent > 25 && percent <= 50) {
            color = "bg-warning";
            label = "Better";
        } else if (percent > 50 && percent <= 75) {
            color = "bg-info";
            label = "Average";
        } else if (percent > 75 && percent <= 100) {
            color = "bg-success";
            label = "Excellent";
        } else if (percent > 100) {
            color = "bg-primary";       // 🔥 over-achievement
            label = "Excess";
        }

        return {
            percent: percent.toFixed(2), // e.g. 900.14%
            color,
            label
        };
    };
    const totalPages = Math.ceil(getFilteredDataCount() / recordsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const goToFirstPage = () => {
        setCurrentPage(1);
    };

    // Reset to first page when search terms change
    useEffect(() => {
        setCurrentPage(1);
    }, [searchState, searchType]);

    // Export function to CSV
    const handleExport = () => {
        const dataToExport = getAllFilteredData();

        // Prepare headers based on userType
        const headers = ['Sr. No.'];
        if (userType === "1") headers.push('Scheme', 'State');
        if (userType === "2") headers.push('District', 'Type');
        if (userType === "3") headers.push('Sub District', 'Type');
        if (userType === "4" || userType === "5") headers.push('Village Name', 'Type');
        if (userType === "1") headers.push('Component Name');
        headers.push('Physical Target', 'Physical Achievement', 'Verified Complete', 'Verified Pending');

        // Convert data to CSV format
        const csvRows = [headers.join(',')];

        dataToExport.forEach((survey, index) => {
            const missionValue = getMissionValueByUserType(survey, userType);

            // Match report with survey
            const report = assignTargetReports.find(
                r => {
                    const stateMatch = String(r.stateCode || '') === String(survey.stateCode || '');
                    if (!stateMatch) return false;

                    const reportType = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                    const surveyType = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';

                    if (reportType && reportType !== '' && reportType !== 'null') {
                        const typeMatch = reportType === surveyType;
                        return stateMatch && typeMatch;
                    }

                    if (userType === "2" && r.districtCode && survey.districtCode) {
                        return stateMatch && (String(r.districtCode) === String(survey.districtCode));
                    }

                    return stateMatch;
                }
            );

            let completeValue = report ? (report.totalSurveyArea || 0) : 0;
            let pendingValue = missionValue - completeValue;

            if (sessionStorage.getItem("finYear") === "2024-2025") {
                pendingValue = 0;
            }

            const row = [];
            row.push(index + 1);

            if (userType === "1") row.push(`"${survey.schemedName || ''}"`, `"${survey.stateName || ''}"`);
            if (userType === "2") {
                row.push(`"${survey.districtName || ''}"`, `"${survey.schemeSubTypeName || ''}"`);
            }
            if (userType === "3") {
                row.push(`"${survey.subDistrictName || ''}"`, `"${survey.schemeSubTypeName || ''}"`);
            }
            if (userType === "4" || userType === "5") {
                row.push(`"${survey.villageName || ''}"`, `"${survey.schemeSubTypeName || ''}"`);
            }
            if (userType === "1") row.push(`"${survey.schemeSubTypeName || ''}"`);

            row.push(
                `${missionValue} ${survey.uomType || ''}`,
                `0 ${survey.uomType || ''}`,
                `${completeValue} ${survey.uomType || ''}`,
                `${pendingValue} ${survey.uomType || ''}`
            );
            csvRows.push(row.join(','));
        });

        // Create CSV content
        const csvContent = csvRows.join('\n');

        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `AssignTarget_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Export function to PDF
    const exportToPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        // ================= LOGO =================
        const logoWidth = 30;
        const logoHeight = 30;
        const logoX = (doc.internal.pageSize.getWidth() - logoWidth) / 2; // center
        const logoY = 10;

        doc.addImage(
            kmLogo,
            "PNG",
            logoX,
            logoY,
            logoWidth,
            logoHeight
        );

        // ================= DATE & TIME =================
        const now = new Date();
        const formattedDateTime = now.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });

        // ================= HEADING =================
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.text(
            "Krishi MApper",
            105,
            48,
            { align: "center" }
        );

        doc.setFontSize(14);
        doc.text(
            "Target Monitoring",
            105,
            56,
            { align: "center" }
        );

        // ================= SUB HEADING =================
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(
            `Generated on: ${formattedDateTime}`,
            105,
            63,
            { align: "center" }
        );

        // ================= TABLE =================
        const dataToExport = getAllFilteredData();
        
        // Prepare table columns based on userType
        const tableColumn = [];
        tableColumn.push("Sr. No.");
        if (userType === "1") tableColumn.push("Scheme", "State");
        if (userType === "2") {
            tableColumn.push("District");
            tableColumn.push("Type");
        }
        if (userType === "3") {
            tableColumn.push("Sub District");
            tableColumn.push("Type");
        }
        if (userType === "4" || userType === "5") {
            tableColumn.push("Village Name");
            tableColumn.push("Type");
        }
        if (userType === "1") tableColumn.push("Component Name");
        tableColumn.push("Physical Target");
        tableColumn.push("Physical Achievement");
        tableColumn.push("Verified Complete");
        tableColumn.push("Verified Pending");

        const tableRows = dataToExport.map((survey, index) => {
        const missionValue = getMissionValueByUserType(survey, userType);
            
            // Match report with survey
            const report = assignTargetReports.find(
                r => {
                    const stateMatch = String(r.stateCode || '') === String(survey.stateCode || '');
                    if (!stateMatch) return false;
                    
                    const reportType = r.targetType || r.schemeSubTypeName || r.schemeSubType || '';
                    const surveyType = survey.schemeSubTypeName || survey.targetType || survey.schemeSubType || '';
                    
                    if (reportType && reportType !== '' && reportType !== 'null') {
                        const typeMatch = reportType === surveyType;
                        return stateMatch && typeMatch;
                    }
                    
                    if (userType === "2" && r.districtCode && survey.districtCode) {
                        return stateMatch && (String(r.districtCode) === String(survey.districtCode));
                    }
                    
                    return stateMatch;
                }
            );

            let completeValue = report ? (report.totalSurveyArea || 0) : 0;
            let pendingValue = missionValue - completeValue;

            if (sessionStorage.getItem("finYear") === "2024-2025") {
                pendingValue = 0;
            }

            const row = [];
            row.push(index + 1);
            
            if (userType === "1") row.push(survey.schemedName || "", survey.stateName || "");
            if (userType === "2") {
                row.push(survey.districtName || "");
                row.push(survey.schemeSubTypeName || "");
            }
            if (userType === "3") {
                row.push(survey.subDistrictName || "");
                row.push(survey.schemeSubTypeName || "");
            }
            if (userType === "4" || userType === "5") {
                row.push(survey.villageName || "");
                row.push(survey.schemeSubTypeName || "");
            }
            if (userType === "1") row.push(survey.schemeSubTypeName || "");
            
            row.push(
                `${missionValue || 0} ${survey.uomType || ""}`,
                `0 ${survey.uomType || ""}`,
                `${completeValue} ${survey.uomType || ""}`,
                `${pendingValue} ${survey.uomType || ""}`
            );

            return row;
        });

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 70, // ⬅ no overlap with heading
            theme: "grid",
            styles: {
                fontSize: 9,
                halign: "center",
                valign: "middle"
            },
            headStyles: {
                fillColor: [46, 125, 50],
                textColor: [255, 255, 255],
                fontStyle: "bold"
            }
        });

        // ================= SAVE =================
        doc.save(`Krishi_Mapper_${now.toISOString().split("T")[0]}.pdf`);
    };

    const goToLastPage = () => {
        setCurrentPage(totalPages);
    };

    const goToPreviousPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const goToNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };
    const getUOMValue = (val) => {
        console.log("Value updated:", val);
        setUom(val);
    };
    const getCurrentDateTime = () => {
        const now = new Date();
        return now.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };
 useEffect(() => {
        setCurrentPage(1);
    }, [searchState, searchType]);

    useEffect(() => {
        if (selectedTypeData) {
            const val = (selectedTypeData?.uomType || "");

            getUOMValue(val);
        }
    }, [selectedTypeData]);


    useEffect(() => {
        if (isEditMode && editRow) {
            setFormData({
                schemeName: editRow.schemedName || editRow.schemeName || "",
                districtName: editRow.districtName || "",
                missionTarget: editRow.centralMission || "",
                finYear: editRow.finYear || "",

            }, [editRow]);

            // IMPORTANT: set separately (select fields)
            setStateValue(editRow.stateCode ? editRow.stateCode.toString() : "NA");
            setUom(editRow.uomType || "");

            // Scheme Sub Type selection
            const matchedOption = getAvailableOptions("main")?.find(
                (opt) => opt.schemeSubTypeName === editRow.schemeSubTypeName
            );

            setSelectedValue(matchedOption ? matchedOption.id.toString() : "NA");
        }
    }, [isEditMode, editRow]);


    // Reset the row values (Sub District and Assign Target)



    const handleRowClear = () => {
        setSelectedValue('');
        setSelectedTypeData({
            revisedTargetByState: '',
            uomType: '',
            centralMission: ''
        });
        setInputValues(prev => ({
            ...prev,
            [0]: {
                ...prev[0],
                districtValue: "",
                assignDistrictTarget: ""
            }
        }));
    };

    useEffect(() => {
        // Always set sessionStorage to current financial year on page load so assignTargetData uses correct year
        const currentFY = getCurrentFinancialYear();
        sessionStorage.setItem("finYear", currentFY);
        surveysCountGroupWise();
        assignTargetData();
        getDistrict();
        handleSubDistrict();
        handleVillage();
        fetchSubSchemeType();
        getStates();
        getScheme();
        if (sessionStorage.getItem("userRoleCodeModel") === "2") {
            setStateValue(sessionStorage.getItem("currentStateName") || "");
        }
    }, []);

    useEffect(() => {
        const joinedTargets = missionTargetSummary
            .filter(item => item.schemeSubTypeName && item.centralMission !== undefined)
            .map(item => `${item.schemeSubTypeName} - ${item.centralMission}`)
            .join(', ');

        setSummaryString(joinedTargets);
        if (missionTargetSummary && missionTargetSummary.length > 0) {
            setRowValues(
                missionTargetSummary.map(() => ({
                    subDistrictValue: '',
                    targetValue: ''
                }))
            );
        }
    }, [missionTargetSummary]);

    useEffect(() => {
        if (missionTargetSummary && missionTargetSummary.length > 0) {
            const initialInputs = {};
            missionTargetSummary.forEach((item, idx) => {
                initialInputs[idx] = {
                    revisedTargetByState: item.revisedTargetByState || ''
                };
            });
            setInputValues(initialInputs);
        }
    }, [missionTargetSummary]);

    // Reset current page when data changes 3333333333
    useEffect(() => {

        setCurrentPage(1);
    }, [assignTargetListing]);

    useEffect(() => {
        sessionStorage.setItem("finYear", finYear);
    }, [finYear]);

    useEffect(() => {
        fetchAssignTargetData();
    }, [finYear]);

    const [inputValues, setInputValues] = useState({});
    const handleChange = (idx, value) => {
        setInputValues(prev => ({

            ...prev,
            [idx]: {
                ...prev[idx],
                revisedTargetByState: value
            }
        }));
    };

    async function surveysCountGroupWise() {
        //alert(sessionStorage.getItem("districtCodeModel"))
        const roleCode = sessionStorage.getItem("userRoleCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel") || 0;
        const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel") || 0;

        const parm = {
            schemeCode,
            stateCode: roleCode >= 2 ? stateCode : 0,
            districtCode: roleCode >= 3 ? districtCode : 0,
            subDistrictCode: roleCode >= 4 ? subDistrictCode : 0,
            userLevel: roleCode
        };

        try {
            const { data } = await axios.post(
                `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/SurveyCountGroupWise/SurveysCountGroupWise`,
                parm
            );
            setLatestSurveyCount(data.dataContent);
        } catch (error) {
            console.error("Error fetching  details:", error);
        }
    }



    const handleAdd = (e) => {
        e.preventDefault();

        if (rows.length < 2) {
            setRows(prevRows => [
                ...prevRows,
                {
                    id: Date.now(),
                    selected: '',
                    custom: '',
                    uom: '',
                    target: ''
                }
            ]);
        } else {
            alert('Maximum 2 type allowed');
        }
    };


    const handleRemove = (id) => {
        setRows(rows.filter(row => row.id !== id));
    };

    const handleSelectChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, selected: value.toString(), custom: '' } : row
        ));
    };

    const handleRowChange = (id, field, value) => {
        setRows(prevRows =>
            prevRows.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };
    const handleSubTypeSelect = (value) => {
        setSelectedValue(value);
    };

    const handleResetEditForm = () => {
        setStateValue('');
        setSelectedValue('');
        setAssignTarget('')
        setUom('');
        setFormData({ ...formData, missionTarget: "" });
        setEditRow(null);
        setShowModals(false)
    };


    const handleEdit = (row) => {
        setEditRow(row);
        //alert(row.stateCode);
        setUom(row.uomType || "");
        setStateValue(row.stateCode?.toString());
        const matchedOption = getAvailableOptions('main').find(
        (opt) => opt.schemeSubTypeName === row.schemeSubTypeName
        );

        setSelectedValue(matchedOption ? matchedOption.id.toString() : "NA");
        // Initialize formData with the row's mission target value
        setFormData({
            ...formData,
            missionTarget: row.centralMission || ""
        });
        setShowModals(true);
    };

    const handleCustomChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, custom: value } : row
        ));
    };

    const handleTargetChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, target: value } : row
        ));
    };

    const getAvailableOptions = (currentId) => {
        // Gather all selected values from rows except the current row
        const rowSelectedValues = rows
            .filter(row => row.id !== currentId)
            .map(row => row.selected)
            .filter(val => val && val !== 'Other');

        let allSelected = [...rowSelectedValues];
        if (currentId === 'main') {
            // For main select, include all row selections (already done)
        } else {
            // For row selects, include main select's value if not 'Other' or 'NA'
            if (selectedValue && selectedValue !== 'Other' && selectedValue !== 'NA') {
                allSelected.push(selectedValue);
            }
        }
        return ddlSubTypeList.filter(option => !allSelected.includes(String(option.id)));
    };
    async function fetchSubSchemeType() {
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const url = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/MissionTarget/MissionTarget/GetSchemaSubTypeList/${schemeCode}`;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                setDDlSubTypeList(data.dataContent);

            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    }

    const handleUpdate = async () => {
        try {
            // Validation
            if (!formData.missionTarget || formData.missionTarget === "") {
                toast.error("Please enter a target value");
                return;
            }

            if (!uom || uom === "") {
                toast.error("Please select a UOM");
                return;
            }

            if (!stateValue || stateValue === "NA") {
                toast.error("Please select a State");
                return;
            }

            if (!selectedValue || selectedValue === "NA") {
                toast.error("Please select a Type");
                return;
            }

            // Ensure we have valid numeric values
            const stateCodeNum = stateValue !== "NA" ? Number(stateValue) : null;
            const subTypeCodeNum = selectedValue !== "NA" ? Number(selectedValue) : null;
            const missionTargetNum = Number(formData.missionTarget);

            if (isNaN(missionTargetNum)) {
                toast.error("Invalid target value");
                return;
            }

            const payload = [
                {
                    "id": editRow.id,
                    "finYear": finYear,
                    "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                    "userTypeCode": sessionStorage.getItem("userRoleCodeModel"),
                    "stateCode": stateCodeNum,
                    "districtCode": null,
                    "subDistrictCode": null,
                    "villageCode": null,
                    "missionTarget": missionTargetNum,
                    "remarks": "Updated target",
                    "createdBy": sessionStorage.getItem("userCodeModel"),
                    "revisedTargetByState": null,
                    "isRevisedByState": "N",
                    "subTypeCode": subTypeCodeNum,
                    "cropCategoryCode": null,
                    "cropNameCode": null,
                    "uomType": uom,
                    "seasons": null,
                    "SchemedId": schemeValue
                }
            ];

            console.log("Update payload:", payload);
            
            const response = await axios.post(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MissionTarget/MissionTarget/UpdateMissionTarget`,
                payload,
                [
                    {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ]
            );

            console.log("Update response:", response.data);
            console.log("Update response status:", response.status);

            // Check if update was successful - be more lenient with success criteria
            const isSuccess = response.data && (
                response.data.statusCode === 200 || 
                response.data.statusCode === "200" || 
                response.data.success === true ||
                response.status === 200 ||
                response.status === 201 ||
                (response.data.message && response.data.message.toLowerCase().includes("success"))
            );

            if (!isSuccess) {
                console.error("Update may have failed. Response:", response.data);
                toast.warning("Update response unclear. Please verify the data was saved.");
            }

            if (isSuccess) {
                // Store the updated values before closing modal
                const updatedMissionTarget = Number(formData.missionTarget);
                const updatedUom = uom;
                const updatedStateCode = stateValue !== "NA" ? Number(stateValue) : null;
                const updatedSchemeCode = editRow ? editRow.schemeCode : null;
                const updatedSubTypeCode = selectedValue !== "NA" ? Number(selectedValue) : null;
                const updatedRowId = editRow?.id;
                const updatedSchemeSubTypeName = editRow?.schemeSubTypeName;

                // Get stateName from statesData based on stateCode
                const selectedState = statesData.find(
                    (state) => state.stateCode && Number(state.stateCode) === updatedStateCode
                );
                const selectedScheme = schemeData.find(
                    (scheme) => scheme.schemeData && Number(scheme.schemedId) === updatedSchemeCode
                );
                const updatedStateName = selectedState ? selectedState.stateName : null;

                // Get the matched option to get schemeSubTypeName from ddlSubTypeList
                let updatedTypeName = null;
                if (selectedValue !== "NA" && selectedValue !== "") {
                    const matchedOption = ddlSubTypeList.find(
                        (opt) => opt.id && opt.id.toString() === selectedValue
                    );
                    updatedTypeName = matchedOption ? matchedOption.schemeSubTypeName : null;
                }
                // If type wasn't changed or couldn't find match, use the existing type name
                if (!updatedTypeName) {
                    updatedTypeName = editRow?.schemeSubTypeName || null;
                }

                // Update local state immediately to reflect changes
                if (editRow) {
                    setAssignTargetListing(prevListing => 
                        prevListing.map(item => {
                            // Match by id if available, otherwise match by stateCode and schemeSubTypeName
                            const isMatch = updatedRowId 
                                ? (item.id === updatedRowId)
                                : (item.stateCode === editRow.stateCode && 
                                   item.schemeSubTypeName === updatedSchemeSubTypeName &&
                                   item.subTypeCode === updatedSubTypeCode);
                            
                            if (isMatch) {
                                return {
                                    ...item,
                                    missionTarget: updatedMissionTarget || item.missionTarget,
                                    centralMission: updatedMissionTarget || item.centralMission,
                                    uomType: updatedUom || item.uomType,
                                    subTypeCode: updatedSubTypeCode !== null ? updatedSubTypeCode : item.subTypeCode,
                                    schemeSubTypeName: updatedTypeName || item.schemeSubTypeName,
                                    stateCode: updatedStateCode !== null ? updatedStateCode : item.stateCode,
                                    stateName: updatedStateName || item.stateName
                                };
                            }
                            return item;
                        })
                    );
                }

                // Show success message
                toast.success("Target updated successfully!");
                
                // Close modal and reset form
                setShowModals(false);
                setEditRow(null);
                setFormData({ ...formData, missionTarget: "" });
                setStateValue('');
                setSelectedValue('NA');
                setUom('');
                
                // Store updated values to preserve them during refresh
                // Also store old values for matching after refresh
                const preserveUpdate = {
                    id: updatedRowId,
                    oldStateCode: editRow?.stateCode,
                    oldSchemeSubTypeName: editRow?.schemeSubTypeName,
                    oldSubTypeCode: editRow?.subTypeCode,
                    stateCode: updatedStateCode,
                    stateName: updatedStateName,
                    schemeSubTypeName: updatedTypeName || updatedSchemeSubTypeName,
                    subTypeCode: updatedSubTypeCode,
                    centralMission: updatedMissionTarget,
                    missionTarget: updatedMissionTarget,
                    uomType: updatedUom
                };

                // Increase delay to ensure update is committed on server before refreshing data
                // Also wait longer to allow server-side caching to clear
                // Use a longer delay to ensure database transaction is committed
                setTimeout(async () => {
                    try {
                        console.log("Refreshing data after update...");
                        await assignTargetData();
                        
                        // After refresh completes, ensure the updated values are preserved if server hasn't caught up
                        // Use setTimeout to ensure state update happens after assignTargetData's state updates
                        setTimeout(() => {
                            console.log("Applying preserved updates after refresh...");
                            setAssignTargetListing(prevListing => {
                                let foundMatch = false;

                                // Determine upfront if a direct ID match exists.
                                // If it does, we MUST NOT use the fallback (stateCode+schemeSubTypeName)
                                // because other rows may share the same combination, causing unintended updates.
                                const hasIdMatch = preserveUpdate.id &&
                                    prevListing.some(item => item.id === preserveUpdate.id);

                                const updated = prevListing.map(item => {
                                    // Primary: match by unique record ID
                                    if (preserveUpdate.id && item.id === preserveUpdate.id) {
                                        foundMatch = true;
                                        return {
                                            ...item,
                                            missionTarget: preserveUpdate.missionTarget,
                                            centralMission: preserveUpdate.centralMission,
                                            uomType: preserveUpdate.uomType || item.uomType,
                                            stateCode: preserveUpdate.stateCode !== null ? preserveUpdate.stateCode : item.stateCode,
                                            stateName: preserveUpdate.stateName || item.stateName,
                                            schemeSubTypeName: preserveUpdate.schemeSubTypeName || item.schemeSubTypeName,
                                            subTypeCode: preserveUpdate.subTypeCode !== null ? preserveUpdate.subTypeCode : item.subTypeCode
                                        };
                                    }

                                    // Fallback: only when no ID match exists in the list.
                                    // This prevents other rows with the same schemeSubTypeName/stateCode
                                    // from being incorrectly updated alongside the target row.
                                    if (!hasIdMatch) {
                                        const matchesOldValues = preserveUpdate.oldStateCode &&
                                            Number(item.stateCode) === Number(preserveUpdate.oldStateCode) &&
                                            item.schemeSubTypeName === preserveUpdate.oldSchemeSubTypeName &&
                                            (preserveUpdate.oldSubTypeCode === null || Number(item.subTypeCode) === Number(preserveUpdate.oldSubTypeCode));

                                        if (matchesOldValues) {
                                            foundMatch = true;
                                            console.log("Matching item found by old values, updating to new values");
                                            return {
                                                ...item,
                                                missionTarget: preserveUpdate.missionTarget,
                                                centralMission: preserveUpdate.centralMission,
                                                uomType: preserveUpdate.uomType || item.uomType,
                                                stateCode: preserveUpdate.stateCode !== null ? preserveUpdate.stateCode : item.stateCode,
                                                stateName: preserveUpdate.stateName || item.stateName,
                                                schemeSubTypeName: preserveUpdate.schemeSubTypeName || item.schemeSubTypeName,
                                                subTypeCode: preserveUpdate.subTypeCode !== null ? preserveUpdate.subTypeCode : item.subTypeCode
                                            };
                                        }
                                    }

                                    return item;
                                });
                                
                                if (!foundMatch && preserveUpdate.id) {
                                    console.warn("Updated item not found in refreshed data. ID:", preserveUpdate.id);
                                }
                                
                                return updated;
                            });
                        }, 200);
                    } catch (error) {
                        console.error("Error refreshing data after update:", error);
                        toast.error("Error refreshing data. Please refresh the page manually.");
                    }
                }, 3000);
            } else {
                throw new Error(response.data?.message || "Update failed");
            }


        } catch (error) {
            console.error("Update failed", error);
            toast.error("Failed to update target. Please try again.");
        }
    };


    const createPayloads = () => {
        const payload = {
            finYear: sessionStorage.getItem("finYear"),
            orgTypeCode: sessionStorage.getItem("userRoleCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };

        const payload_Report = {
            str_FinYear: sessionStorage.getItem("finYear"),
            userLevel: sessionStorage.getItem("userRoleCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };

        return {
            payload: payload,
            payload_Report: payload_Report
        };
    };

    // Optimized fetch function with reusable API call helper
    const fetchAssignTargetData = async () => {
        try {
            const { payload, payload_Report } = createPayloads();
            const baseURL = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;

            // Helper function for API calls
            const makeApiCall = async (endpoint, payload) => {
                const response = await fetch(`${baseURL}${endpoint}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                return response.json();
            };

            // Try first API
            const result = await makeApiCall(
                "/api/MissionTarget/MissionTarget/getMissionTargetSummary1",
                payload
            );

            // Check if first API returned valid data
            if (result?.dataContent?.length > 0) {
                //  setAssignTargetListing([]);
                // return;
            }

            // Fallback to second API
            // console.log("First API returned empty/null, using fallback API");
            const result_Report = await makeApiCall(
                "/api/SurveyCountGroupWise/SurveysCountGroupWiseNew",
                payload_Report
            );


            if (result_Report?.dataContent?.length > 0) {
                // Transform fallback data to match first API structure
                const transformedData = result_Report.dataContent.map(item => ({
                    schemeName: item.schemeName || null,
                    stateName: item.stateName || null,
                    districtName: item.districtName || null,
                    subDistrictName: item.subDistrictName || null,
                    villageName: item.villageName || null,
                    // schemeSubTypeName: item.schemeSubTypeName || null,
                    schemeSubTypeName: item.targetType || null,
                    subTypeCode: null,
                    cropGroupName: null,
                    cropName: null,
                    cropCategoryCode: null,
                    cropNameCode: item.cropNameCode || null,
                    stateCode: item.stateCode || null,
                    schemeCode: item.schemeCode || null,
                    districtCode: item.districtCode || null,
                    subDistrictCode: item.subDistrictCode || null,
                    villageCode: item.villageCode || null,
                    centralMission: item.centralMission || null,
                    stateMission: 0,
                    districtMission: 0,
                    subDistrictMission: 0,
                    villageMission: 0,
                    pending: 0,
                    // complete: item.totalSurvey,
                    complete: item.totalSurveyArea,
                    revisedTargetByState: null,
                    isRevisedByState: "N"
                }));
                console.log('transformedData:', transformedData);
                //setAssignTargetListing([]);
                setAssignTargetListing(transformedData);
                console.log('setAssignTargetListing fallback:', assignTargetListing);
                setAssignTargetReports(result_Report.dataContent);
                setAssignTargetListing(prevState => {
                    console.log("Previous state:", prevState.length, "records");
                    console.log("New state:", transformedData.length, "records");
                    return transformedData;
                });
            } else {
                setAssignTargetListing([]);
                setAssignTargetReports([]);
            }

        } catch (error) {
            console.error("Error fetching assign target data:", error);
            setAssignTargetListing([]);
            setAssignTargetReports([]);
        }
    };

    // Add this to see when setAssignTargetListing is called
    useEffect(() => {
        console.log("assignTargetListing updated:", assignTargetListing.length, "records");
    }, [assignTargetListing]);

    // Use functional update to avoid race conditions

    const assignTargetData = async (yearOverride) => {
        const activeFinYear =
            yearOverride != null && yearOverride !== ""
                ? String(yearOverride)
                : (sessionStorage.getItem("finYear") || getCurrentFinancialYear());
        const payload = {
            finYear: activeFinYear,
            orgTypeCode: sessionStorage.getItem("userRoleCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };

        const payload_Report = {
            str_FinYear: activeFinYear,
            userLevel: sessionStorage.getItem("userRoleCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };
        console.log('assignTargetData 111 payload for second api', payload);
        console.log('assignTargetData 111 payload_Report', payload_Report);
        //const response;
        let response;

        try {

            response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MissionTarget/MissionTarget/getMissionTargetSummary`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            const response_Report = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SurveyCountGroupWise/SurveysCountGroupWiseNew`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload_Report),
                }
            );

            const result_Report = await response_Report.json();
            const missionRows = Array.isArray(result?.dataContent) ? result.dataContent : [];
            setAssignTargetReports(result_Report.dataContent);
            console.log('result.dataContent ', result.dataContent);
            console.log('result_Report.dataContent ', result_Report.dataContent);
            // Debug: Log sample data structures
            if (missionRows.length > 0) {
                console.log('Sample survey data structure:', {
                    keys: Object.keys(missionRows[0]),
                    sample: missionRows[0]
                });
            }
            if (result_Report.dataContent && result_Report.dataContent.length > 0) {
                console.log('Sample report data structure:', {
                    keys: Object.keys(result_Report.dataContent[0]),
                    sample: result_Report.dataContent[0]
                });
            }
            
            // Helper function to enrich data with scheme names
            const enrichWithSchemeNames = (data) => {
                if (!data || !Array.isArray(data)) return data;
                return data.map(item => {
                    const scheme = schemeData.find(s => Number(s.schemedId) === Number(item.schemedId || item.schemeCode));
                    return {
                        ...item,
                        schemedName: scheme ? scheme.schemedName : (item.schemedName || '')
                    };
                });
            };
            
            // Update listing from mission API; clear table when FY has no rows (do not keep stale data)
            const userTypeCode = sessionStorage.getItem("userRoleCodeModel");

            if (userTypeCode !== "2" && userTypeCode !== "3" && userTypeCode !== "4") {
                if (missionRows.length > 0) {
                    setAssignTargetListing(enrichWithSchemeNames(missionRows));
                } else {
                    setAssignTargetListing([]);
                    setMissionTargetSummary([]);
                    setGroupedSchemeData([]);
                }
            }
            if (userTypeCode === "2" && userTypeCode !== "3" && userTypeCode !== "4") {
                if (missionRows.length > 0) {
                    setAssignTargetListing(enrichWithSchemeNames(missionRows));
                } else {
                    setAssignTargetListing([]);
                    setMissionTargetSummary([]);
                    setGroupedSchemeData([]);
                }
            }
            if (userTypeCode !== "2" && userTypeCode === "3" && userTypeCode !== "4") {
                if (missionRows.length > 0) {
                    setAssignTargetListing(enrichWithSchemeNames(missionRows));
                } else {
                    setAssignTargetListing([]);
                    setMissionTargetSummary([]);
                    setGroupedSchemeData([]);
                }
            }
            if (sessionStorage.getItem("userRoleCodeModel") === "2") {
                setAssignTarget(missionRows[0]?.centralMission);
                setMissionTargetSummary(enrichWithSchemeNames(missionRows.filter(
                    item => Number(item.centralMission) !== 0
                )));

                const groupedCounts = missionRows
                    .filter(item => Number(item.districtMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalDistrictMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalDistrictMission += Number(item.districtMission);
                        return groups;
                    }, {});

                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);
                console.log('Grouped by schemeSubTypeName with counts:', groupedArray);


            } if (sessionStorage.getItem("userRoleCodeModel") === "3") {
                if (missionRows.length > 0) {
                    setMissionTargetSummary(enrichWithSchemeNames(missionRows.filter(
                        item => Number(item.districtMission) !== 0
                    )));
                    setAssignTargetListing(enrichWithSchemeNames(missionRows.filter(
                        item => Number(item.districtMission) === 0
                    )));
                } else {
                    setMissionTargetSummary([]);
                    setAssignTargetListing([]);
                    setGroupedSchemeData([]);
                }

                const groupedCounts = missionRows
                    .filter(item => Number(item.subDistrictMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalsubDistrictMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalsubDistrictMission += Number(item.subDistrictMission);
                        return groups;
                    }, {});

                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);
                console.log('Grouped by schemeSubTypeName with counts 111:', groupedArray);


            } if (sessionStorage.getItem("userRoleCodeModel") === "4") {
                if (missionRows.length > 0) {
                    setAssignSubDistrictTarget(missionRows[0]?.villageMission);
                    setMissionTargetSummary(enrichWithSchemeNames(missionRows.filter(
                        item => Number(item.villageMission) === 0
                    )));
                    setAssignTargetListing(enrichWithSchemeNames(missionRows.filter(
                        item => Number(item.villageMission) !== 0
                    )));
                } else {
                    setAssignSubDistrictTarget("");
                    setMissionTargetSummary([]);
                    setAssignTargetListing([]);
                    setGroupedSchemeData([]);
                }
                const groupedCounts = missionRows
                    .filter(item => Number(item.villageMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalvillageMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalvillageMission += Number(item.villageMission);
                        return groups;
                    }, {});

                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);
                console.log('Grouped by schemeSubTypeName with counts villageMission:', groupedArray);

            }

            setRevisedByState(missionRows[0]?.isRevisedByState);
            setRevisedTargetByState(missionRows[0]?.revisedTargetByState);
            // Check conditions for showing modal
            if (

                sessionStorage.getItem("userRoleCodeModel") === "2" &&
                missionRows.some(item => {
                    const state = item?.isRevisedByState?.trim();
                    return state === "Y"
                })
            ) {
                console.log("result.dataContent----------", missionRows)
                // setShowModal(true);
            } else {
                //setShowModal(true); 
            }


        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
    };

function getScheme() {
        const fetchScheme = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MissionTarget/MissionTarget/GetMTSchemedList`
            );
            setSchemeData(result.data.dataContent);
        };
        fetchScheme();
    }
    function getStates() {
        const fetchStates = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }

    // Filter states based on selected scheme.
    const getFilteredStates = useMemo(() => {
        const selectedScheme = schemeData.find(
            (scheme) => scheme.schemedId && Number(scheme.schemedId) === Number(schemeValue)
        );
        const schemeName = selectedScheme?.schemedName || currentSchemeName || '';

        const isCRM = schemeName.toUpperCase().includes('CRM');
        if (isCRM) {
            const allowedStates = ['DELHI', 'PUNJAB', 'HARYANA', 'MADHYA PRADESH', 'UTTAR PRADESH'];
            return statesData.filter((state) =>
                allowedStates.includes((state.stateName || '').toUpperCase())
            );
        }

        return statesData;
    }, [schemeValue, schemeData, statesData, currentSchemeName]);


    function getDistrict() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            stateCode: Number(sessionStorage.getItem("stateNameModel")),
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/district`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setDistrictData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));

    }
    const handleVillage = () => {
        console.log('handleVillage called');

        var stateCode = sessionStorage.getItem("stateNameModel");
        var districtCode = sessionStorage.getItem("districtCodeModel");
        var subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        if ((stateCode !== null && stateCode !== "0") && (districtCode !== null && districtCode !== "0") && (subDistrictCode !== null && subDistrictCode !== "0")) {

            var raw = JSON.stringify({
                stateCode,
                districtCode,
                subDistrictCode

            });
            console.log('raw: ', raw);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            )


                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent;
                    console.log('localFormDataVillage: ', localFormDataVillage);
                    let myArrayVillage = [];
                    localFormDataVillage.map((item, key) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })
                    setOptionVillage(myArrayVillage)
                })
                .catch((error) => console.log("error", error));

        }

        console.log('optionVillage: ', optionVillage);

    }

    const handleSubDistrict = (value) => {
        const districtCode = sessionStorage.getItem("districtCodeModel")

        if (districtCode === null) {
            setDistrictValue(districtCode);
        } else {

            setDistrictValue(value);
        }



        if (districtCode === "NA") return;

        const raw = JSON.stringify({
            districtcode: districtCode,
        });

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => setSubDistrictData(result.dataContent))
            .catch((error) => console.log("Error fetching sub-districts:", error));
    };
    const handleSubmit = async (status) => {

        // Validation for the main row
        if (status === 0) {
            // Validate state selection
            if (stateValue === "NA" || !stateValue) {
                alert("Please select a State before assigning the target.");
                return; // Stop further processing
            }
            if (!assignTarget || isNaN(assignTarget) || Number(assignTarget) <= 0) {
                //toast.error("Please enter a valid Assign Target for the first row");
                alert("Please enter a valid Assign Target for the first row");
                return;
            }
            if (selectedValue === "NA" || !selectedValue) {
                alert("Please select a Type before assigning the target.");
                return; // Stop further processing
            }
            if (uom === "NA" || !uom) {
                alert("Please select a UOM before assigning the target.");
                return; // Stop further processing
            }
            if (selectedValue === 'Other' && (!txtlType || txtlType.trim() === "")) {
                alert(`Please enter a value for 'Enter Type' at first row`);
                return;
            }

        }

        let isValid = true;

        if (!isValid) return;

        if (status === 4) {
            //alert(uom);
            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = rowValues[0]?.targetValue;

            // 1. Validate the Sub District Dropdown
            const subDistrictValue = rowValues[0]?.subDistrictValue;
            if (!subDistrictValue || subDistrictValue === "") {
                alert("Please select a Sub District.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            // 3. Validate against total Assign Target for this schemeSubTypeName
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            //console.log('existingAssignTargets-totalDistrictMission: ', existingAssignTargets[0]?.totalDistrictMission);

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalsubDistrictMission)
                ? 0
                : existingAssignTargets[0].totalsubDistrictMission;

            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            // 4. Validation logic based on Assign By State
            // Get the original data from missionTargetSummary to get Assign By State
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            const assignByState = Number(originalData?.districtMission || 0); // This is the Assign By State value

            // Validate against Assign By State
            if (totalAssignTargetForScheme > assignByState) {
                alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By State (${assignByState}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`);
                return; // Stop the entire function
            }

            console.log('rowValues--------', selectedItem)
            // Create payload based on selected type
            const payload = [{
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: selectedItem.schemeCode,
                stateCode: selectedItem.stateCode,
                districtCode: selectedItem.districtCode,
                subDistrictCode: rowValues[0]?.subDistrictValue || '',
                missionTarget: rowValues[0]?.targetValue || '',
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                subTypeCode: selectedItem.subTypeCode,
                uomType: uom,
                schemedId: schemeValue
            }];

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);

                    // Reset form inputs
                    setRowValues(prev =>
                        prev.map((row, i) => ({
                            ...row,
                            subDistrictValue: "",
                            targetValue: ""
                        }))
                    );

                    // Reset SubType to "Choose" and clear Assign By State
                    setSelectedValue('');
                    setSelectedTypeData({
                        districtName: '',
                        uomType: '',
                        districtMission: ''
                    });

                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else if (status === 3) {
            // Validate scheme selection
            if (!schemeValue || schemeValue === "NA") {
                alert("Please select a Scheme before assigning the target.");
                return;
            }

            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }
            console.log("inputValues-----", inputValues)
            const assignTargetValue = inputValues[0]?.assignDistrictTarget;

            // 1. Validate the District Dropdown
            const districtValue = inputValues[0]?.districtValue;
            if (!districtValue || districtValue === "NA") {
                alert("Please select a District.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            // 3. Validate that Assign Target is not greater than the available target
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            //const PreviousSubSchemCount = existingAssignTargets[0]?.totalDistrictMission;
            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalDistrictMission)
                ? 0
                : existingAssignTargets[0].totalDistrictMission;
            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            // 4. CORRECTED Validation logic based on Target Revised By State
            // Get the original data from missionTargetSummary to get correct Target Revised By State
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            //console.log('originalData: ', originalData);
            const targetRevisedByState = Number(originalData?.revisedTargetByState || 0); // This is the actual Target Revised By State
            const assignByCentral = Number(originalData?.centralMission || 0); // This is the actual Assign By Central

            let availableTarget;
            let alertMessage;

            if (targetRevisedByState === 0) {
                // If Target Revised By State is 0, validate against Assign By Central
                availableTarget = assignByCentral;
                alertMessage = `Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By Central (${availableTarget}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`;
            } else {
                // If Target Revised By State > 0, validate against Target Revised By State
                availableTarget = targetRevisedByState;
                alertMessage = `Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Target Revised By State (${availableTarget}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`;
            }

            if (totalAssignTargetForScheme > availableTarget) {
                alert(alertMessage);
                return; // Stop the entire function
            }
            console.log('inputValues--------', inputValues)
            // Create payload based on selected type
            const payload = [{
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: schemeValue && schemeValue !== "NA" ? schemeValue : sessionStorage.getItem("schemeCodeModel"),
                stateCode: selectedItem.stateCode,
                districtCode: inputValues[0]?.districtValue || "",
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                missionTarget: inputValues[0]?.assignDistrictTarget || "",
                subTypeCode: selectedItem.subTypeCode,
                uomType: uom,
                schemedId: schemeValue
            }];

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);
                    setAssignTarget("");
                    setSelectedValue('');
                    setRows([]);
                    setShowModal(false);
                    setInputValues(prev => ({
                        ...prev,
                        [0]: {
                            ...prev[0],
                            districtValue: "",
                            assignDistrictTarget: ""
                        }
                    }));
                    // Reset Type to "Choose" and clear Assign By Central
                    setSelectedTypeData({
                        revisedTargetByState: '',
                        uomType: '',
                        centralMission: ''
                    });
                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else if (status === 5) {
            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = rowValues[0]?.targetValue;

            // 1. Validate the Village Dropdown
            const villageValue = rowValues[0]?.villageValue;
            if (!villageValue || villageValue === "") {
                alert("Please select a Village.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            //// 3. Validate that Assign Target is not greater than the available target
            //const assignTarget = Number(assignTargetValue);
            //const subDistrictMission = Number(selectedItem.subDistrictMission);

            //if (assignTarget > subDistrictMission) {
            //    alert(`The Assign Target (${assignTarget}) cannot be greater than the Assign By Sub District (${subDistrictMission}).`);
            //    return; // Stop the entire function
            //}

            // 3. Validate against total Assign Target for this schemeSubTypeName
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            // const PreviousSubSchemCount = existingAssignTargets[0]?.totalvillageMission;

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalvillageMission)
                ? 0
                : existingAssignTargets[0].totalvillageMission;
            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            console.log('totalAssignTargetForScheme: ', totalAssignTargetForScheme);

            // 4. Validation logic based on Assign By Sub District
            // Get the original data from missionTargetSummary to get Assign By Sub District
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            const assignBySubDistrict = Number(originalData?.subDistrictMission || 0); // This is the Assign By Sub District value

            // Validate against Assign By Sub District
            if (totalAssignTargetForScheme > assignBySubDistrict) {
                alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By Sub District (${assignBySubDistrict}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`);
                return; // Stop the entire function
            }
            console.log('rowValues2--------', rowValues)
            // Create payload based on selected type
            const payload = [{
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: selectedItem.schemeCode,
                stateCode: selectedItem.stateCode,
                districtCode: selectedItem.districtCode,
                subDistrictCode: selectedItem.subDistrictCode,
                villageCode: rowValues[0]?.villageValue || '',
                missionTarget: rowValues[0]?.targetValue || '',
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                subTypeCode: selectedItem.subTypeCode,
                uomType: uom,
                schemedId: schemeValue
            }];
            //console.log('payload at v: ', payload);
            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);

                    // Reset form inputs
                    setRowValues(prev =>
                        prev.map((row, i) => ({
                            ...row,
                            villageValue: "",
                            targetValue: ""
                        }))
                    );

                    // Reset SubType to "Choose" and clear Assign By Sub District
                    setSelectedValue('');
                    setSelectedTypeData({
                        revisedTargetByState: '',
                        uomType: '',
                        centralMission: ''
                    });
                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else {
            // --- Create an array for all targets ---
            const targets = [];
            const isRevisedChar = isStateRevised ? 'Y' : 'N';

            // 1. Add the main/fixed row
            const mainRowTarget = {
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: sessionStorage.getItem("schemeCodeModel"),
                stateCode: sessionStorage.getItem("userRoleCodeModel") === "1" ? stateValue : sessionStorage.getItem("stateNameModel"),
                districtCode: districtValue === 'null' ? '0' : districtValue,
                subDistrictCode: subDistrictValues || 0,
                villageCode: villageCode || 0,
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                missionTarget: assignTarget,
                UOMType: uom,
                schemedId: schemeValue,
                subTypeName: selectedValue === 'Other' ? txtlType : null,
                subTypeCode: selectedValue === '' ? -1 : selectedValue,
                IsRevisedByState: isRevisedChar,
            };
            targets.push(mainRowTarget);


            for (const [index, row] of rows.entries()) {
                // Validation for dynamic rows
                console.log("rowrowrow------>>>>>>>>>>>", row)
                if (!row.target || isNaN(row.target) || Number(row.target) <= 0) {
                    alert(`Please enter a valid Assign Target at Row ${index + 2}.`);
                    return;
                }

                if (!row.selected) {
                    //toast.error(`Row ${index + 1}: Please select a type for all added rows.`);
                    alert(`Please select a Type at Row ${index + 2}.`);
                    return;
                }

                if (row.selected === 'Other' && !row.custom) {
                    alert(`Please enter a value for 'Enter Type' at Row ${index + 2}.`);
                    return;
                }

                const dynamicRowTarget = {
                    ...mainRowTarget, // Copy common properties
                    missionTarget: row.target, // Use the row's specific target
                    UOMType: row.uom,
                    subTypeName: row.selected === 'Other' ? row.custom : null,
                    subTypeCode: row.selected === 'Other' ? -1 : row.selected,
                    IsRevisedByState: isRevisedChar,
                };
                targets.push(dynamicRowTarget);
            }

            console.log("missionTargetSummary-----uom", missionTargetSummary);

            // If status === 2, use missionTargetSummary with revisedTarget values as payload
            let payloadToSend = targets;
            if (status === 2 && Array.isArray(missionTargetSummary) && missionTargetSummary.length > 0) {
                payloadToSend = missionTargetSummary.map((item, idx) => ({
                    ...item,
                    finYear: sessionStorage.getItem("finYear"),
                    userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                    createdBy: sessionStorage.getItem("userCodeModel"),
                    UOMType: uom,
                    subTypeCode: item.subTypeCode,
                    IsRevisedByState: "Y",
                    RevisedTargetByState: inputValues[idx]?.revisedTargetByState || '',
                    // RevisedTargetByState: inputValues[idx] || '',
                    missionTarget: item.centralMission, // Use centralMission for each item
                    schemedId: schemeValue || item.schemedId || sessionStorage.getItem("schemeCodeModel")
                }));
                console.log('POST payload (missionTargetSummary with revised fields):', payloadToSend);
            } else {
                console.log('POST payload (default targets):', payloadToSend);
            }
            //alert(selectedValue);
            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,// Manvendra
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payloadToSend), // Send the array
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData(); // Refresh
                    toast.success(result.message);
                    // Clear fields
                    setAssignTarget("");
                    setStateValue("NA");
                    setSelectedValue('');
                    setRows([]);
                    setShowModal(false);
                } else {
                    toast.error("Failed to assign target else: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
    };

    const handleClear = () => {
        //console.log('handleClear');
        setAssignTarget("");
        setSelectedValue("");
        setTxtlType(""); // Also clear the 'Other' text field
        setStateValue("NA");
        // Remove all dynamically added rows
        setRows([]);
    };


    return (

        <>
            <ToastContainer autoClose={7000} />

            {/* This page is only for schemeCode="16" (MNT), so always render AdminSideBarMnt.
                The AdminSideBarNew branch below was for other scheme codes and is no longer needed:
                sessionStorage.getItem("schemeCodeModel") === "16"
                    ? <AdminSideBarMnt />
                    : <AdminSideBarNew />   ← removed (other-scheme branch) */}
            <AdminSideBarMnt />
            <AdminHeaderNew />

            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Assign Target</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">Assign Target</li>
                        </ol>
                    </nav>
                </div>
                <div>
                    <div className="row mb-4">
                        <div className="col-md-2 finacildd_label">
                            <div className="form-group text-white">
                                <label htmlFor="finYear" className="form-label text-white">Financial Year</label>
                                <select
                                    id="finYear"
                                    name="finYear"
                                    className="form-select"
                                    value={finYear}
                                    onChange={handleFinYearChange}
                                >
                                    <option value="2026-2027">2026-2027</option>
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2024-2025">2024-2025</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Rashmi*/}
                <section className="section dashboard asigntarget">
                    <div className="row surveydetailsBg">
                        {/* Dead code — condition (userType !== "1" && !== "2" && !== "3" && !== "4" && !== "5")
                            can never be true for any valid user, so these blocks never render.
                        {userType !== "1" && userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (
                            <>
                                <div className="col-md-3">
                                    <label htmlFor="finYear" className="form-label assignlbl">Financial Year</label>
                                    <input
                                        type="text"
                                        id="finYear"
                                        className="form-control"
                                        name="finYear"
                                        value={finYear}
                                        readOnly
                                    />
                                </div>
                            </>
                        )}
                        {userType !== "1" && userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (
                            <div className="col-md-2">
                                <label htmlFor="schemeName" className="form-label assignlbl">State</label>
                                <input
                                    type="text"
                                    id="schemeName"
                                    className="form-control"
                                    name="schemeName"
                                    value={currentStateName}
                                    readOnly
                                />
                            </div>
                        )}
                        */}

                        {userType === "4" && (
                            <>
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Sub District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign By Sub District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Village</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign Target</label>
                                    </div>
                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);

                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        revisedTargetByState: '',
                                                        uomType: '',
                                                        centralMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            revisedTargetByState: selectedItem.revisedTargetByState || '',
                                                            uomType: selectedItem.uomType || '',
                                                            centralMission: selectedItem.subDistrictMission || '' // Use subDistrictMission for sub-district level
                                                        });
                                                    }
                                                }
                                                handleVillage();
                                                // Reset village select and assign target
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        villageValue: "",
                                                        targetValue: ""
                                                    }))
                                                );
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue)?.subDistrictName || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={
                                                (selectedTypeData.centralMission || "") +
                                                "   " +
                                                (selectedTypeData.uomType || "")
                                            }
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        villageValue: e.target.value
                                                    }))
                                                )
                                            }
                                            value={rowValues[0]?.villageValue || ""}
                                        >
                                            <option value="">Choose...</option>
                                            {optionVillage && optionVillage.map((villageItem, villageIdx) => (
                                                <option key={villageIdx} value={villageItem.value}>
                                                    {villageItem.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={rowValues[0]?.targetValue || ""}
                                            placeholder="Enter target"
                                            onChange={(e) => {
                                                const val = e.target.value;

                                                if (val === "" || Number(val) >= 0) {
                                                    setRowValues((prev) =>
                                                        prev.map((row, i) =>
                                                            i === 0
                                                                ? { ...row, targetValue: val }
                                                                : row
                                                        )
                                                    );
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "+" || e.key === "-" || e.key.toLowerCase() === "e") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        {userType === "3" && (
                            <>
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign By State</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Sub District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign Target</label>
                                    </div>
                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);

                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        districtName: '',
                                                        uomType: '',
                                                        districtMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            districtName: selectedItem.districtName || '',
                                                            uomType: selectedItem.uomType || '',
                                                            districtMission: selectedItem.districtMission || ''
                                                        });
                                                    }
                                                }

                                                // Reset sub district select and assign target
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        subDistrictValue: "",
                                                        targetValue: ""
                                                    }))
                                                );
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={selectedTypeData.districtName || ''}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={
                                                (selectedTypeData?.districtMission || "") +
                                                "   " +
                                                (selectedTypeData?.uomType || "")
                                            }
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        subDistrictValue: e.target.value
                                                    }))
                                                )
                                            }
                                            value={rowValues[0]?.subDistrictValue || ""}
                                        >
                                            <option value="">Choose...</option>
                                            {subDistrictData && subDistrictData.map((subItem, subIdx) => (
                                                <option key={subIdx} value={subItem.subDistrictCode}>
                                                    {subItem.subDistrictName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={rowValues[0]?.targetValue || ""}
                                            placeholder="Enter target"
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || Number(val) >= 0) {
                                                    setRowValues((prev) =>
                                                        prev.map((row, i) =>
                                                            i === 0 ? { ...row, targetValue: val } : row
                                                        )
                                                    );
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "+" || e.key === "-" || e.key.toLowerCase() === "e") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}


                        {sessionStorage.getItem("userRoleCodeModel") === "2" && (
                            <>
                                {/* Header Row: Only labels */}
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Target Revised By State</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign By Central</label>
                                    </div>

                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign Target</label>
                                    </div>
                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);
                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty

                                                    setSelectedTypeData({
                                                        revisedTargetByState: '',
                                                        uomType: '',
                                                        centralMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            revisedTargetByState: selectedItem.revisedTargetByState || '',
                                                            uomType: selectedItem.uomType || '',
                                                            centralMission: selectedItem.centralMission || ''
                                                        });
                                                    }
                                                }
                                                // Reset district select and assign target
                                                setInputValues(prev => ({
                                                    ...prev,
                                                    [0]: {
                                                        ...prev[0],
                                                        districtValue: "",
                                                        assignDistrictTarget: ""
                                                    }
                                                }));
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeData.revisedTargetByState || 0}
                                            readOnly
                                        />
                                    </div>


                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={
                                                (selectedTypeData?.centralMission || "") +
                                                "   " +
                                                (selectedTypeData?.uomType || "")
                                            }
                                            readOnly
                                        />

                                    </div>

                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setInputValues(prev => ({
                                                    ...prev,
                                                    [0]: {
                                                        ...prev[0],
                                                        districtValue: e.target.value
                                                    }
                                                }))
                                            }
                                            value={inputValues[0]?.districtValue || ""}
                                        >
                                            <option defaultValue value="NA">
                                                Choose...
                                            </option>
                                            {districtData && districtData.map((dItem, dIdx) => (
                                                <option key={dIdx} value={dItem.districtCode}>
                                                    {dItem.districtName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={inputValues[0]?.assignDistrictTarget || ""}
                                            placeholder="Enter target"
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || Number(val) >= 0) {
                                                    setInputValues((prev) => ({
                                                        ...prev,
                                                        [0]: {
                                                            ...prev[0],
                                                            assignDistrictTarget: val
                                                        }
                                                    }));
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "+" || e.key === "-" || e.key.toLowerCase() === "e") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>

                                </div>
                            </>
                        )}
                        
                        {/*12-08-2025*/}

                        {/* schemeCodeModel === "16" check removed — this page is exclusively for scheme 16 (MNT),
                            so that condition is always true and adds no value. */}
                        {sessionStorage.getItem("userRoleCodeModel") === "1" && (
                            <>
                                <div className="row">
                                    <div className="col-md-2">
                                        <label htmlFor="finYear" className="form-label assignlbl">Financial Year</label>
                                        <input
                                            type="text"
                                            id="finYearStatic"
                                            className="form-control"
                                            name="finYear"
                                            value={finYear}
                                            readOnly
                                        />

                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="scheme" className="form-label assignlbl">Scheme</label>
                                        <select
                                            id="scheme"
                                            className="form-select"
                                            value={schemeValue}
                                            onChange={(e) => setSchemeValue(e.target.value)}
                                            onClick={getScheme} // consider moving to useEffect instead
                                        >
                                            <option value="NA">Choose...</option>
                                            {schemeData.map((item, idx) => (
                                                <option key={idx} value={item.schemedId}>
                                                    {item.schemedName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="state" className="form-label assignlbl">State</label>
                                        <select
                                            id="state"
                                            className="form-select"
                                            value={stateValue}
                                            onChange={(e) => setStateValue(e.target.value)}
                                            onClick={getStates} // consider moving to useEffect instead
                                        >
                                            <option value="NA">Choose...</option>
                                            {getFilteredStates.map((item, idx) => (
                                                <option key={idx} value={item.stateCode}>
                                                    {item.stateName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>



                                </div>

                                <div className="row mt-3" style={{ borderBottom: '1px dashed  #ccc' }}></div>


                                <div className="row mt-2">
                                    <div className="col-md-2">
                                        <label htmlFor="ddlType" className="form-label assignlbl">
                                            Type
                                        </label>
                                        <select
                                            id="ddlType"
                                            className="form-select"
                                            onChange={(e) => handleSubTypeSelect(e.target.value)}
                                            value={selectedValue}>
                                            <option defaultValue value="NA">
                                                Choose...
                                            </option>
                                            {getAvailableOptions('main').map(option => (
                                                <option key={option.id} value={option.id.toString()}>
                                                    {option.schemeSubTypeName}
                                                </option>
                                            ))}
                                            {/*<option value="Other">Other</option>*/}
                                        </select>
                                    </div>

                                    <div className="col-md-2">
                                        <label htmlFor="assignTarget" className="form-label assignlbl">
                                            Assign Target
                                        </label>
                                        <input
                                            type="number"
                                            id="assignTarget"
                                            className="form-control"
                                            name="assignTarget"
                                            placeholder={targetPlaceholder}
                                            value={assignTarget}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || Number(val) >= 0) {
                                                    setAssignTarget(val);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "-" || e.key.toLowerCase() === "e" || e.key === "+") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onFocus={() => setTargetPlaceholder("")}
                                            onBlur={() => {
                                                if (!assignTarget) setTargetPlaceholder("000000"); // fixed variable name
                                            }}
                                        />

                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="uom" className="form-label assignlbl">UOM</label>
                                        <select
                                            id="uom"
                                            name="uom"
                                            className="form-select"
                                            value={uom}
                                            onChange={(e) => setUom(e.target.value)}
                                        >
                                            <option value="">Choose...</option>
                                            <option value="Nos">Nos</option>
                                            <option value="Area(ha)">Area (ha)</option>
                                            <option value="Meter">Meter</option>
                                        </select>
                                    </div>
                                    {selectedValue === 'Other' && (
                                        <div className="col-md-2">
                                            <label htmlFor="txtType" className="form-label assignlbl">
                                                Enter Type
                                            </label>
                                            <input
                                                type="text"
                                                id="txtType"
                                                className="form-control"
                                                name="txtType"
                                                placeholder="Enter custom option"
                                                value={txtlType}
                                                onChange={(e) => setTxtlType(e.target.value)}
                                            />
                                        </div>
                                    )}
                                    <div className="col-md-1">
                                        <label className="form-label" style={{ color: 'transparent' }}>Add</label>
                                        <a href="#" onClick={handleAdd} className="btn btn-primary w-100 mt-1"><i className="bi bi-plus"></i></a>
                                    </div>
                                </div>

                            </>
                        )}
                        {rows.map((row, index) => (
                            <div className="row mt-2 align-items-end" key={row.id}>

                                {/* TYPE DROPDOWN */}
                                <div className="col-md-2">
                                    <label htmlFor={`ddlType-${row.id}`} className="form-label assignlbl">
                                        Type
                                    </label>
                                    <select
                                        id={`ddlType-${row.id}`}
                                        className="form-control"
                                        value={row.selected}
                                        onChange={(e) => handleSelectChange(row.id, e.target.value)}
                                    >
                                        <option value="">Choose...</option>
                                        {getAvailableOptions(row.id).map(option => (
                                            <option key={option.id} value={option.id.toString()}>
                                                {option.schemeSubTypeName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* UOM DROPDOWN */}

                                {/* TARGET INPUT */}
                                <div className="col-md-2">
                                    <label htmlFor={`assignTarget-${row.id}`} className="form-label assignlbl">
                                        Assign Target
                                    </label>
                                    <input
                                        type="number"
                                        id={`assignTarget-${row.id}`}
                                        className="form-control"
                                        placeholder="000000"
                                        value={row.target}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === "" || Number(val) >= 0) {
                                                handleTargetChange(row.id, val);
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (["-", "e", "+"].includes(e.key.toLowerCase())) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label assignlbl">UOM</label>
                                    <select
                                        className="form-select"
                                        value={row.uom}
                                        onChange={(e) => handleRowChange(row.id, "uom", e.target.value)}
                                    >
                                        <option value="">Choose...</option>
                                        <option value="Nos">Nos</option>
                                        <option value="Area(ha)">Area (ha)</option>
                                        <option value="Meter">Meter</option>
                                    </select>
                                </div>


                                {/* CUSTOM TYPE FIELD (ONLY WHEN SELECTED = OTHER) */}
                                {row.selected === "Other" && (
                                    <div className="col-md-3 mt-2">
                                        <label htmlFor={`txtType-${row.id}`} className="form-label assignlbl">
                                            Enter Type
                                        </label>
                                        <input
                                            id={`txtType-${row.id}`}
                                            className="form-control"
                                            type="text"
                                            value={row.custom}
                                            placeholder="Enter custom option"
                                            onChange={(e) => handleCustomChange(row.id, e.target.value)}
                                        />
                                    </div>
                                )}

                                {/* REMOVE BUTTON */}
                                <div className="col-md-1">
                                    <label className="form-label" style={{ color: "transparent" }}>Remove</label>
                                    <button
                                        className="btn btn-danger w-100"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleRemove(row.id);
                                        }}
                                    >
                                        <i className="bi bi-dash"></i>
                                    </button>
                                </div>

                            </div>
                        ))}


                        {userType === "2" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(3)}>

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClear} >
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType === "4" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(5)} >

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClearVillage} >
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType === "3" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(4)} >
                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClearSubDistrict} >
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType != "4" && userType != "2" && userType != "3" && userType != "5" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-5">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(0)} >

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleClear} >
                                    Clear
                                </button>
                            </div>

                        )}

                        <div className="col-md-12">
                            <div className="bigbox1 mt-4">
                                <div className="card">
                                    {/* Search and Export Controls */}
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        
                                        <div className="col-md-6 d-flex gap-2">
                                            {sessionStorage.getItem("userRoleCodeModel") === "1" &&(
                                            <div className="col-md-6">
                                                <select
                                                    className="form-select"
                                                    value={searchState}
                                                    onChange={(e) => setSearchState(e.target.value)}
                                                >
                                                    <option value="">All States</option>
                                                    {statesData.map((item, idx) => (
                                                        <option key={idx} value={item.stateName}>{item.stateName}</option>
                                                    ))}
                                                </select>
                                            </div>
    )}
    {sessionStorage.getItem("userRoleCodeModel") === "2" && (
 <div className="col-md-6">
    
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setInputValues(prev => ({
                                                    ...prev,
                                                    [0]: {
                                                        ...prev[0],
                                                        districtValue: e.target.value
                                                    }
                                                }))
                                            }
                                            value={inputValues[0]?.districtValue || ""}
                                        >
                                            <option defaultValue value="NA">
                                                Choose...
                                            </option>
                                            {districtData && districtData.map((dItem, dIdx) => (
                                                <option key={dIdx} value={dItem.districtCode}>
                                                    {dItem.districtName}
                                                </option>
                                            ))}
                                        </select>
                                   
 </div>
    )}
                                            <div className="col-md-6">
                                                <select
                                                    className="form-select"
                                                    value={searchType}
                                                    onChange={(e) => setSearchType(e.target.value)}
                                                >
                                                    <option value="">All Types</option>
                                                    {getAvailableOptions('main').map((option, idx) => (
                                                        <option key={idx} value={option.schemeSubTypeName}>{option.schemeSubTypeName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div>
                                            <button
                                                className="btn btn-success btn-sm"
                                                onClick={handleExport}
                                                title="Export to CSV"
                                            >
                                                <i className="bi bi-download"></i> Export List
                                            </button>
                                            <button className="btn btn-danger btn-sm" onClick={exportToPDF}>
                    Export to PDF
                </button>
                                        </div>
                                    </div>
                                    <div className="">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    {userType === "1" && <th>Scheme</th>}
                                                    {userType === "1" && <th>State</th>}
                                                    {userType === "2" && <th>District</th>}
                                                    {userType === "2" && <th>Type</th>}
                                                    {userType === "3" && <th>Sub District</th>}
                                                    {userType === "3" && <th>Type</th>}
                                                    {userType === "4" && <th>Village Name</th>}
                                                    {userType === "4" && <th>Type</th>}
                                                    {userType === "5" && <th>Village Name</th>}
                                                    {userType === "5" && <th>Type</th>}
                                                    {/* {userType === "1" && <th>Permission to Revise by State</th>} */}
                                                    {userType === "1" && <th>Component Name</th>}
                                                    

                                                    <th>Physical Target</th>
                                                    {/* <th colSpan={2}>Verified by Krishi MApper </th> */}
                                                    <th>Physical Achievement</th>
                                                    <th className="highlight-target-header" style={{ whiteSpace: 'normal', lineHeight: '1.4' }}>
                                                        <span style={{ color: 'black', fontWeight: 'bold' }}>Target Achieved</span><small className="text-muted">(KM Calculated)</small><br />
                                                        <span className="blinking-asterisk">*</span>
                                                        <span style={{ color: 'blue', fontSize: '0.9em' }}>(Area calculated based on polygon area)</span>
                                                    </th>
                                                     <th >Target Achieved % </th>
                                                    {(userType === "1" || userType === "2") && (<th>Action</th>)}


                                                </tr>
                                                {/* <tr>
                                                    <td colSpan={
                                                        userType === "1"
                                                            ? 6
                                                            : userType === "2"
                                                                ? 5
                                                                : userType === "3"
                                                                    ? 4
                                                                    : userType === "4"
                                                                        ? 4
                                                                        : userType === "5"
                                                                            ? 4
                                                                            : 2
                                                    }>
                                                    </td>
                                                    <td className="targetdone">Complete</td>
                                                    <td className="targetpanding">Pending</td>
                                                    <td></td>

                                                </tr> */}
                                            </thead>

                                            <tbody>
    {(() => {
        let serialNumber = (currentPage - 1) * recordsPerPage + 1;
        console.log("getPaginatedData",getPaginatedData);
        return getPaginatedData().map((survey, index) => {
            
            const missionValue = getMissionValueByUserType(survey, userType);

            const report = assignTargetReports.find(s => {
                const isBaseMatch =
                    Number(s.stateCode) === Number(survey.stateCode) &&
                    Number(s.componentId) === Number(survey.subTypeCode) &&
                    String(s.uomType) === String(survey.uomType);

                if (userType === "2") {
                    return (
                        isBaseMatch &&
                        String(s.districtCode || "") === String(survey.districtCode || "")
                    );
                }

                return isBaseMatch;
            });

            // ✅ If report not found → value = 0
            const completeValue = Number(report?.totalSurveyArea || 0);

            let pendingValue = missionValue - completeValue;
            if (sessionStorage.getItem("finYear") === "2024-2025") {
                pendingValue = 0;
            }

            return (
                <tr key={index}>
                    <td>{serialNumber++}</td>
                    {userType === "1" && <td>{survey.schemedName}</td>}
                    {userType === "1" && <td>{survey.stateName}</td>}
                    
                    {userType === "2" && <td>{survey.districtName}</td>}
                    {userType === "3" && <td>{survey.subDistrictName}</td>}
                    {(userType === "4" || userType === "5") && <td>{survey.villageName}</td>}

                    <td>{survey.schemeSubTypeName}</td>

                    {/* Physical Target */}
                    <td className="fw-semibold text-danger">
                        {missionValue} {survey.uomType}
                    </td>

                    {/* Physical Achievement (manual or state) */}
                    {/* <td>0 {survey.uomType}</td> */}

                    {/* Verified Complete */}
                    {/* <td className="fw-semibold text-success">
                        {completeValue} {survey.uomType}
                    </td>

                    
                    <td className="fw-semibold text-danger">
                        {Math.max(0, pendingValue)} {survey.uomType}
                    </td> */}
                     <td>{survey.physicalAchievment}{survey.uomType}</td>

                                                                {/* ✅ Complete value from report OR 0 */}
                                                                <td className="fw-semibold text-success">
                                                                    {completeValue} {survey.uomType}
                                                                </td>
<td style={{ minWidth: "160px" }}>
                                                                    {(() => {
                                                                        const meta = getAchievementMeta(missionValue, completeValue);

                                                                        return (
                                                                            <>
                                                                                <div className="d-flex justify-content-between mb-1">
                                                                                    <small className="fw-semibold">{meta.percent}%</small>
                                                                                    <small className="fw-bold">{meta.label}</small>
                                                                                </div>

                                                                                <div className="progress" style={{ height: "12px" }}>
                                                                                    <div
                                                                                        className={`progress-bar ${meta.color}`}
                                                                                        role="progressbar"
                                                                                        style={{ width: `${meta.percent}%` }}
                                                                                        aria-valuenow={meta.percent}
                                                                                        aria-valuemin="0"
                                                                                        aria-valuemax="100"
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </td>

                    {(userType === "1" || userType === "2") && (
                        <td>
                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => handleEdit(survey)}
                            >
                                ✏️
                            </button>
                        </td>
                    )}
                </tr>
            );
        });
    })()}
</tbody>


                                        </table>

                                        {/* Pagination Controls */}
                                        {totalPages > 1 && (
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="pagination-info">
                                                    Showing {indexOfFirstRecord + 1} to {Math.min(indexOfLastRecord, getFilteredDataCount())} of {getFilteredDataCount()} entries
                                                </div>
                                                <nav aria-label="Page navigation">
                                                    <ul className="pagination mb-0">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={goToFirstPage}
                                                                disabled={currentPage === 1}
                                                            >
                                                                First
                                                            </button>
                                                        </li>
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={goToPreviousPage}
                                                                disabled={currentPage === 1}
                                                            >
                                                                Previous
                                                            </button>
                                                        </li>

                                                        {/* Page Numbers */}
                                                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                            let pageNumber;
                                                            if (totalPages <= 5) {
                                                                pageNumber = i + 1;
                                                            } else if (currentPage <= 3) {
                                                                pageNumber = i + 1;
                                                            } else if (currentPage >= totalPages - 2) {
                                                                pageNumber = totalPages - 4 + i;
                                                            } else {
                                                                pageNumber = currentPage - 2 + i;
                                                            }

                                                            return (
                                                                <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => handlePageChange(pageNumber)}
                                                                    >
                                                                        {pageNumber}
                                                                    </button>
                                                                </li>
                                                            );
                                                        })}

                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={goToNextPage}
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Next
                                                            </button>
                                                        </li>
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={goToLastPage}
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                Last
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {showModal && sessionStorage.getItem("userRoleCodeModel") === "2" && (
                    <div className="modal fade show d-block edittargrt" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Target Revised By State</h5>

                                </div>
                                <div className="modal-body">
                                    <p>For the <b className="helights"> Financial Year {finYear}, </b>  target of <b className="helights"> {summaryString} surveys </b> under the <b className="helights"> {currentSchemeName}</b> scheme has been assigned to the state of
                                        <b className="helights"> {currentStateName} </b> by the Central Government. You have the option to revise this target and set it as per your preference. However,
                                        If you choose not to revise it, you will have to work with the target
                                        assigned by the Central Government. So, would you like to revise your target?</p>


                                    <div class="col-md-12 d-flex justify-content-md-center mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-success farmrbtn me-2"
                                            onClick={() => {
                                                setShowTargetInput(true);
                                                setIsYesButtonDisabled(true);
                                            }}
                                            disabled={isYesButtonDisabled}
                                        >
                                            Yes
                                        </button>
                                        <button type="button" className="btn btn-success me-md-2" onClick={() => handleSubmit(1)} >No</button>
                                    </div>


                                    {showTargetInput && (
                                        <div className="col-md-12 mt-3">
                                            {missionTargetSummary && missionTargetSummary.length > 0 ? (
                                                missionTargetSummary.map((item, idx) => (
                                                    <div key={idx} className="row align-items-center mb-2">
                                                        <label className="col-md-4 col-form-label">
                                                            {item.schemeSubTypeName}
                                                        </label>
                                                        <div className="col-md-6">
                                                            <input
                                                                type="text"
                                                                className="form-control targetinput"
                                                                name={`revisedTarget_${idx}`}
                                                                placeholder="000000"
                                                                value={inputValues[idx]?.revisedTargetByState || ''}
                                                                onChange={e => handleChange(idx, e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>No mission target summary available.</div>
                                            )}
                                            <div className="d-flex justify-content-md-center mt-3">
                                                <button type="button" className="btn btn-success farmrbtn me-2" onClick={() => {
                                                    // Update missionTargetSummary with input values
                                                    const updated = missionTargetSummary.map((item, idx) => ({
                                                        ...item,
                                                        revisedTarget: inputValues[idx] || ''
                                                    }));

                                                    handleSubmit(2);
                                                }}>
                                                    Revise Target
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </div>
                )}

                {showModals && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header bg-success">
                                    <h5 className="modal-title">✏️ Update Target</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowModals(false)}
                                    />
                                </div>

                                <div className="modal-body">
                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <label className="form-label">Scheme</label>
                                            <input className="form-control" value={editRow.schemedName || editRow.schemeName || ''} disabled />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Financial Year</label>
                                            <input className="form-control" value={finYear} disabled />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">State</label>
                                            <select
                                                id="state"
                                                className="form-select"
                                                value={stateValue}
                                                onChange={(e) => setStateValue(e.target.value)}
                                                onClick={getStates}
                                            >
                                                <option value="NA">Choose...</option>
                                                {getFilteredStates.map((item, idx) => (
                                                    <option key={idx} value={item.stateCode}>
                                                        {item.stateName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* <div className="col-md-6">
                                            <label className="form-label">District</label>
                                            <input
                                                className="form-control"
                                                value={editRow.districtName || "-"}
                                                disabled
                                            />
                                        </div> */}

                                        <div className="col-md-3">
                                            <label className="form-label">Target</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={formData.missionTarget}
                                                onChange={(e) =>
                                                    setFormData({ ...formData, missionTarget: e.target.value })
                                                }
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">UOM</label>
                                            <select
                                                id="uom"
                                                name="uom"
                                                className="form-select"
                                                value={uom}
                                                onChange={(e) => setUom(e.target.value)}
                                            >
                                                <option value="">Choose...</option>
                                                <option value="Nos">Nos</option>
                                                <option value="Area(ha)">Area (ha)</option>
                                                <option value="Meter">Meter</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="ddlType" className="form-label assignlbl">
                                                Type
                                            </label>
                                            <select
                                                id="ddlType"
                                                className="form-select"
                                                onChange={(e) => handleSubTypeSelect(e.target.value)}
                                                value={selectedValue}
                                            >
                                                <option value="NA">Choose...</option>

                                                {getAvailableOptions("main").map((option) => (
                                                    <option key={option.id} value={option.id.toString()}>
                                                        {option.schemeSubTypeName}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>

                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-bg-danger"
                                        onClick={handleResetEditForm}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="btn btn-success"
                                        onClick={handleUpdate}
                                    >
                                        Update Target
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

            </main>

            <AdminFooterNew />
        </>
    );
}

export default AssignTargetMNT;